import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {login} from '@/services/AuthService';
import store from '..';

export interface ILoginAction {
  email: string;
  password: string;
}

@Module({ name: 'auth', store, dynamic: true })
export class AuthModule extends VuexModule {
  public user: any = null;
  public token: string | null = localStorage.getItem('token');

  @Mutation
  public setUser(user: any) {
    this.user = user;
  }

  @Mutation
  public setToken(token: string) {
    this.token = token;
  }

  get loggedIn(): boolean {
    return !!this.user;
  }

  @Action({ rawError: true })
  public async login(payload: ILoginAction) {
    const res = await login(payload.email, payload.password);

    if (res.status === 200) {
      const user = res.data.data.user;
      const token = res.data.data.token;
      localStorage.setItem('token', token);
      this.context.commit('setUser', user);
      this.context.commit('setToken', token);

      return { success: true, response: res };
    }

    return { success: false, response: res };
  }

  @Action({ rawError: true })
  public logout() {
    localStorage.removeItem('token');
    this.context.commit('setToken', null);
    this.context.commit('setToken', null);
  }
}

export const ModuleAuth = getModule(AuthModule);
